import { useMutation, useQueryClient } from "@tanstack/react-query";
import { hunterTerminalsForReservationKeys } from "Api/Queries/Merchants/useGetHunterTerminalsForReservationQuery";
import { merchantKeys } from "Api/Queries/Merchants/useGetMerchantQuery";
import { orbitLStatusKeys } from "Api/Queries/Merchants/useGetOrbitLStatusQuery";
import { postMerchantsPublicIDOrbitLReserveTerminals } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Parameters = {
  merchantPublicID: string;
  facilityPublicID: string;
  terminalPublicIDs?: Array<string> | null;
  terminalCount?: number | null;
  softPosCount?: number | null;
};

type Props = {
  onSuccess?: () => void;
  onError?: (error: unknown) => void;
};

export const useReserveTerminalsMutation = ({
  onSuccess,
  onError,
}: Props = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      ({
        merchantPublicID,
        facilityPublicID,
        terminalPublicIDs,
        terminalCount,
        softPosCount,
      }: Parameters) =>
        postMerchantsPublicIDOrbitLReserveTerminals(
          { facilityPublicID, terminalPublicIDs, terminalCount, softPosCount },
          merchantPublicID,
        ),
    ),
    onSuccess: (_, { merchantPublicID }: Parameters) => {
      queryClient.invalidateQueries({
        queryKey:
          hunterTerminalsForReservationKeys.byMerchantPublicId(
            merchantPublicID,
          ),
      });
      queryClient.invalidateQueries({
        queryKey: merchantKeys.byMerchantPublicId(merchantPublicID),
      });
      queryClient.invalidateQueries({
        queryKey: orbitLStatusKeys.byMerchantPublicId(merchantPublicID),
      });
      onSuccess?.();
    },
    onError,
  });
};
